import { render, staticRenderFns } from "./SupplierObat.vue?vue&type=template&id=51ef0d5c"
import script from "./SupplierObat.vue?vue&type=script&setup=true&lang=js"
export * from "./SupplierObat.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports